import Axios from "axios";
import { ResourceGenerator } from "@swan/api";

export default (object: string, recordId: number) =>
  ResourceGenerator(Axios, `auth/record_permissions/${object}/${recordId}`);
